module.exports = __WEBPACK_EXTERNAL_MODULE_32__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 32
// module chunks = 0